import { Fragment, useEffect, useLayoutEffect, useState } from "react";
import { Input, Pagination, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import config from "@/config";

import { EmptyComponent } from "@/components/ui/EmptyComponent";
import { LoadingComponent } from "@/components/ui/LoadingComponent";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaDollarSign } from "react-icons/fa6";
import CvService from "@/services/CvService";
import PropertiesService from "@/services/PropertiesService";

const Cv = () => {
    const ITEM_PER_PAGE = 6;
    const [cv, setCv] = useState([]);
    const [cvAvatars, setCvAvatars] = useState([]);
    const [cvHot, setCvHot] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [loading, setLoading] = useState(true);

    const [searchText, setSearchText] = useState("");
    const [searchProvince, setSearchProvince] = useState("");
    const [province, setProvince] = useState([]);
    const [searchJob, setSearchJob] = useState("");
    const [jobs, setJobs] = useState([]);
    const [query, setQuery] = useState({});


    // JOB
    useEffect(() => {
        PropertiesService.getFilter({ ParentCode: "J001" }).then((res) => {
            setJobs([
                { Code: '', Name: 'Tất cả nghề nghiệp' },
                ...res.Data
            ]);
        })
        PropertiesService.getFilter({ ParentCode: "J003" }).then((res) => {
            setProvince([
                { Code: '', Name: 'Tất cả Tỉnh/Thành' },
                ...res.Data
            ]);
        })
        CvService.getCvNoiBat().then((res) => setCvHot(res))
    }, []);

    useEffect(() => {
        CvService.getListCV({ ...query, pageNo: currentPage, elemPerPage: ITEM_PER_PAGE }).then((res) => setCv(res))
        CvService.getCvAvatars({ ...query, pageNo: currentPage - 1, elemPerPage: ITEM_PER_PAGE }).then((res) => setCvAvatars(res))
    }, [query, currentPage]);

    const handleChangePage = (page) => {
        setCurrentPage(page)
    }

    const handleSearch = () => {
        const filter = {};
        if (searchJob !== '') filter.jobsId = searchJob;
        if (searchProvince !== '') filter.locationId = searchProvince;
        if (searchText) filter.inputSearch = searchText;
        setQuery(filter);
    }

    // function handleSearch() {
    //     const cvByName = cv.filter(item => searchCvName ? item.name.toLowerCase().includes(searchCvName.toLowerCase()) : true)
    //     const cvByJob = cvByName.filter(item => job.value === 'ALL' ? true : item.codePosition === job.value)
    //     const cvByProvince = cvByJob.filter(item => province.value === 'ALL' ? true : item.codeAddress === province.value)
    //     setCv(cvByProvince)
    // }

    // const page = cv.slice(currentPage * ITEM_PER_PAGE, (currentPage + 1) * ITEM_PER_PAGE)
    // const cvHotPage = cvHot.slice(currentPage * 4, (currentPage + 1) * 4)
    if (cv.length === 0 && cvAvatars.length === 0) {
        return <LoadingComponent />
    }

    return (
        <div
            className="container xl:container flex flex-col mx-auto p-4 lg:p-8">
            <div className={"flex justify-between border border-b-0 rounded-t-xl overflow-hidden border-gray-200"}>
                <div
                    className={
                        "w-full rounded-t-xl p-5 bg-gradient-to-tl from-green-400 via-green-500 to-green-700 animate-gradient"
                    }
                    style={{
                        backgroundSize: "200% 200%",
                        animation: "gradient-animation 6s ease infinite",
                    }}
                >            {/* <div className={"w-full  p-5  bg-primary  text-white"}> */}
                    <h1 className={"text-3xl text-white font-bold "}>CV Ứng Tuyển</h1>
                    <p className={"text-white"}>Danh Sách Ứng Viên Tuyển Dụng</p>
                </div>
            </div>

            <div className="w-full bg-gradient-to-b from-gray-200 to-gray-0 flex justify-center rounded-bl-lg rounded-br-lg border border-t-0 border-gray-200
          gap-2 p-2
          flex-wrap lg:flex-nowrap lg:p-4">
                <div className=" w-full flex gap-2 flex-col md:flex-row">
                    <Input
                        variant="outlined"
                        prefix={<SearchOutlined className="text-gray-400" />}
                        placeholder="Nhập từ khóa tìm kiếm"
                        className="w-full md:w-2/3  h-12 text-base"
                        onChange={e => setSearchText(e.target.value)}
                    />

                    <div className="w-full md:w-1/3 h-12">
                        <Select
                            onChange={(e) => setSearchJob(e)}
                            value={searchJob}
                            showSearch
                            placeholder="Tất cả Nghề nghiệp"
                            fieldNames={{ value: "Code", label: "Name" }}
                            style={{ width: "100%", height: "100%" }}
                            options={jobs}
                            notFoundContent={
                                <div className="text-red-500 text-center">
                                    Không tìm thấy công việc
                                </div>
                            }

                        />
                    </div>
                    <div className="w-full md:w-1/3 h-12">
                        <Select
                            onChange={(e) => setSearchProvince(e)}
                            placeholder="Tất cả Tỉnh/Thành"
                            value={searchProvince}
                            fieldNames={{ value: "Code", label: "Name" }}
                            showSearch
                            style={{ width: "100%", height: "100%" }}
                            options={province}
                            notFoundContent={
                                <div className="text-red-500 text-center">
                                    Không tìm thấy Tỉnh/Thành
                                </div>
                            }

                        />
                    </div>
                </div>
                <button
                    type="primary"
                    className=" w-full h-12 px-8 bg-primary hover:bg-primary-hover rounded-lg text-white font-semibold border-none text-base transition-all
                            lg:w-1/4"
                    onClick={handleSearch}
                >
                    Tìm Kiếm
                </button>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 mt-4">

                <div className="w-full lg:w-2/3 p-3 lg:p-4 rounded-lg shadow-lg lg:border-2 lg:border-gray-200">
                    <div className="flex flex-col gap-2 lg:flex-row  lg:items-center  justify-between">
                        <p className="text-2xl font-medium">
                            Đang có <span className="text-gray-600">({cv.length})</span> hồ sơ ứng tuyển
                        </p>
                    </div>

                    <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 mt-6 ">

                        {cv.map((e, index) => (
                            <Link
                                key={index}
                                to={config.routes.detailCv + `${e.PK}`}
                                className="flex gap-4 p-4 border border-gray-200 shadow-lg rounded-lg transition-all hover:scale-105 hover:cursor-pointer hover:bg-green-100 hover:border-primary-hover">
                                <img className="w-24 h-24 object-contain shrink-0" src={config.ImageConfig.getLogo(
                                    cvAvatars.find(a => a.PK === e.PK)?.Avatar
                                )} alt="avatar" />
                                <div className="flex flex-col justify-between gap-1.5">
                                    <h2 className="text-xl font-medium">{e.FullName}</h2>
                                    <p className="text-gray-500 font-medium">{e.MajorName}</p>
                                    <div className="flex -mx-1 text-gray-500 divide-x divide-gray-300 overflow-hidden">
                                        <div className=" px-1 flex gap-0.5 items-center "><FaMapMarkerAlt
                                            className="flex-shrink-0" /><span
                                                className="line-clamp-1">{e.LocationName}</span>
                                        </div>
                                        <div className=" px-1 flex gap-0.5 items-center "><FaDollarSign
                                            className="flex-shrink-0" /> <span
                                                className="line-clamp-1">{e.SalaryName}</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}

                    </div>

                    {cv.length === 0 && (
                        <EmptyComponent description={"Cv"} />

                    )}

                    <div className="flex items-center justify-center mt-8">
                        <Pagination
                            onChange={(e) => handleChangePage(e)}
                            responsive={true}
                            defaultCurrent={currentPage}
                            total={1000}
                            pageSize={ITEM_PER_PAGE}
                            showSizeChanger={false}
                        />
                    </div>
                </div>

                <div
                    className="w-full h-fit sticky top-24 lg:w-1/3 p-3 flex flex-col gap-4 lg:p-4 rounded-lg shadow-lg lg:border-2 lg:border-gray-200">
                    <h2 className="text-2xl font-bold uppercase">ỨNG VIÊN NỔI BẬT</h2>
                    <hr className="border bg-green-500" />
                    <div className="flex flex-col gap-4">
                        {cvHot.map((e, index) => (
                            <div
                                key={index}
                                className="flex gap-4 p-4 border-b border-gray-200 rounded-lg hover:bg-green-100 cursor-pointer">
                                <img className="w-28 h-28 shrink-0 object-contain" src={config.ImageConfig.getLogo(
                                    cvAvatars.find(a => a.PK === e.PK)?.Avatar
                                )} alt="avatar" />
                                <div className="flex flex-col justify-between">
                                    <h2 className="text-xl font-bold">{e.FullName}</h2>
                                    <p className="text-blue-500 text-2xl font-normal">{e.MajorName}</p>
                                    <p className="font-medium">Địa chỉ: {e.LocationName}</p>
                                    <p className="font-medium">Mức lương: {e.SalaryName}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className={"flex justify-center"}>
                        <button
                            className="bg-blue-500 w-3/4 transition-all font-semibold hover:bg-blue-800 text-white p-2 rounded-lg">Xem
                            thêm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cv;
